<div class="skin-fit">
  <div class="hidden lg:block">
    <div class="mb-6 flex items-center">
      <div class="mr-4 h-1 w-6 bg-primary-md-dark lg:w-12"></div>
      <div class="text-xl font-medium text-primary-darkest lg:text-3xl">
        Dashboard
      </div>
    </div>
  </div>
  <div class="content space-y-8 pb-10">
    <section class="skin-fit">
      <div class="skin-fit-header mb-4">
        <div class="title text-center font-bold">
          <h3 class="text-5xl font-semibold text-primary-darkest">Skin Fit</h3>
        </div>
      </div>
      <div
        class="skin-fit-card rounded-md bg-primary-lightest p-5"
        *ngIf="skinFit.id && !loadSkinFit">
        <div class="last-update text-center lg:text-right">
          <span
            class="inline-block rounded-md bg-primary-darkest py-1 px-3 text-sm text-white"
            >Last Update :
            {{ skinFit.updated_at | date: 'dd MMM yyyy h:mm a' }}</span
          >
        </div>
        <div class="skin-fit-detail my-3">
          <div class="skin-info m-0 grid gap-10 lg:grid-cols-12 lg:px-4">
            <div class="mb-4 text-center lg:col-span-4">
              <img
                class="mx-auto aspect-[9/16] w-full max-w-[300px] rounded-md object-cover"
                src="{{ skinFit.file_path }}"
                alt="skin-fit" />
            </div>
            <div class="space-y-3 lg:col-span-8">
              <div
                class="skin-problems m-0 grid grid-cols-2 gap-3 lg:grid-cols-4">
                <div
                  class="skin-problem cursor-pointer rounded-md p-3 text-center hover:bg-white"
                  *ngFor="let skinFitContent of skinFitContents; let i = index"
                  [ngClass]="{ 'bg-white shadow-md': skinFitContent.isActive }"
                  (click)="selectFaceAnalization(i)">
                  <div class="skin-pict mb-2" *ngIf="skinFitContent.image">
                    <div>
                      <img
                        class="mx-auto h-[60px] w-[60px]"
                        [ngClass]="!skinFitContent.status ? 'grayscale' : ''"
                        src="{{ skinFitContent.image }}"
                        alt="" />
                    </div>
                  </div>
                  <div class="skin-pict mb-2" *ngIf="!skinFitContent.image">
                    <div
                      class="mx-auto"
                      [style]="
                        'width:  60px; height:  60px; background-color: #' +
                        skinFitContent.colour +
                        '; border-radius: 14px;'
                      "></div>
                  </div>
                  <span class="text-sm">{{ skinFitContent.name }}</span>
                  <p
                    *ngIf="!skinFitContent.colour"
                    class="mt-2"
                    [ngClass]="{
                      'text-primary-md-dark': skinFitContent.isActive
                    }"
                    style="font-weight: 600">
                    {{
                      skinFitContent.status
                        ? (skinFitContent.confidence | number: '1.0-0')
                        : (1 | number: '1.0-0')
                    }}
                    %
                  </p>
                </div>
              </div>
              <div class="skin-description">
                <h3 class="text-2xl text-primary-md-dark">
                  {{ selectedSkinFitContent.name }}
                </h3>
                <p>{{ selectedSkinFitContent.description }}</p>
                <div class="flex items-center gap-x-5">
                  <div class="skin-fit-action my-3">
                    <button
                      class="rounded-md bg-primary-md-dark py-2 px-4 text-white"
                      (click)="openSkinFitModal()">
                      Analyse Again
                    </button>
                  </div>
                  <div class="my-3 text-primary-md-dark">
                    <a
                      class="txt-p-md-dark text-md"
                      [routerLink]="['/user/skin-fit']"
                      >Show History
                      <fa-icon
                        class="icon"
                        [icon]="faArrowCircleRight"></fa-icon
                    ></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="skin-fit-empty text-center"
        *ngIf="!skinFit.id && !loadSkinFit">
        <img
          class="mx-auto mb-3"
          style="max-width: 250px"
          src="assets/images/skin-fit/skin-fit-analyse.png"
          alt="Empty Skin Fit" />
        <div class="skin-fit-action my-3 text-center">
          <button
            class="mx-auto hidden rounded-md bg-primary-md-dark py-2 px-4 text-white lg:block"
            (click)="openSkinFitModal()">
            Analyse Your Skin
          </button>
          <button
            class="mx-auto rounded-md bg-primary-md-dark py-2 px-4 text-white lg:hidden"
            (click)="navigateTo('/user/skin-fit/analyse')">
            Analyse Your Skin
          </button>
        </div>
      </div>
      <div class="loading text-center" *ngIf="loadSkinFit">
        <fa-icon class="load-icon" [icon]="faSpinner" [spin]="true"></fa-icon>
      </div>
    </section>
    <section class="latest-order space-y-4">
      <h3 class="uppercase text-primary-darkest">Latest Order</h3>
      <div class="order-list space-y-3" *ngIf="!loadOrder">
        <div
          class="shop-card overflow-hidden rounded-md shadow-md"
          *ngFor="let order of orders; let i = index">
          <div class="sc-header bg-primary-lightest p-3">
            <div class="content flex items-center justify-between">
              <div
                class="shop flex items-center gap-5"
                [routerLink]="['/shop', order.shop.slug]">
                <div class="shop-img-wrapper">
                  <div
                    class="c-img-r h-[40px] w-[40px] overflow-hidden rounded-full">
                    <img
                      class="h-[40px] w-[40px]"
                      [src]="
                        order.shop.logo_path
                          ? order.shop.logo_path
                          : shopDefaultImg
                      "
                      [alt]="order.shop.name"
                      (error)="handleShopImgError()" />
                  </div>
                </div>
                <div class="shop-info">
                  <div
                    class="shop-name text-lg font-bold uppercase text-primary-darkest line-clamp-1">
                    {{ order.shop_name }}
                  </div>
                </div>
              </div>
              <div class="c-btn-group-rtl action flex items-center gap-3">
                <button
                  class="btn-detail py-1 px-3 text-primary-md-dark"
                  [routerLink]="['/user/order', order.id]">
                  Details
                </button>
                <!-- note: need modal buy again -->
                <!-- <button
                class="rounded-md bg-primary-md-dark py-1 px-3 text-white"
                (click)="openBuyAgainModal(order.shop_name, order.lines)">
                Beli Lagi
              </button> -->
              </div>
            </div>
          </div>
          <div class="sc-body">
            <div
              class="order-info items-center gap-3 border-b border-primary-md-dark/30 p-3 lg:flex">
              <div class="oi-item order-no flex-1">
                <div class="label text-xs uppercase text-primary-darkest/50">
                  ORDER NO:
                </div>
                <div class="value text-right text-primary-md-dark lg:text-left">
                  ORDER#{{ order.id }}
                </div>
              </div>
              <div class="oi-item order-date flex-1">
                <div class="label text-xs uppercase text-primary-darkest/50">
                  ORDER DATE:
                </div>
                <div class="value text-right lg:text-left">
                  {{ order.formatted_created_date }}
                </div>
              </div>
              <div class="oi-item status flex-1">
                <div class="label text-xs uppercase text-primary-darkest/50">
                  Status:
                </div>
                <div class="value text-right lg:text-left">
                  <span
                    class="status-badge rounded-md bg-primary-md-dark py-0.5 px-3 text-xs text-white"
                    >{{ translateOrderStatus(order.status) }}</span
                  >
                </div>
              </div>
              <div class="oi-item total-order flex-1">
                <div class="label text-xs uppercase text-primary-darkest/50">
                  Order Totals:
                </div>
                <div class="value text-right text-red-500 lg:text-left">
                  {{ order.total | fcCurrency }}
                </div>
              </div>
            </div>
            <div class="product-list divide-y divide-primary-md-dark/30">
              <div
                class="product-item flex items-center gap-3 p-3"
                *ngFor="
                  let product of order.lines
                    | slice: 0:(pToggle[i] ? order.total_order_lines : 2)
                ">
                <div class="flex w-full items-center gap-3 lg:w-1/2">
                  <div
                    class="product-img-wrapper h-[60px] w-[60px] overflow-hidden rounded-md border border-primary-md-dark">
                    <img
                      class="h-[60px] w-[60px] rounded-md"
                      [src]="
                        product.product_default_image_path &&
                        product.product_default_image_path[0].small
                          ? product.product_default_image_path[0].small.path
                          : productDefaultImg
                      "
                      [alt]="product.product_name"
                      class="product-img"
                      (error)="handleProductImgError()" />
                  </div>
                  <div class="product-info flex-1">
                    <div class="product-name text-primary-darkest line-clamp-1">
                      {{ product.product_brand.name }} -
                      {{ product.product_name }}
                    </div>
                    <div
                      class="product-variant text-xs text-primary-darkest/50"
                      *ngIf="product.product_variant_name">
                      Varian: {{ product.product_variant_name }}
                    </div>
                  </div>
                </div>

                <div
                  class="product-price hidden flex-1 text-primary-md-dark lg:block">
                  {{ product.unit_price | fcCurrency }}
                </div>
                <div
                  class="product-price text-right text-primary-md-dark lg:flex-1 lg:text-left">
                  {{ product.total | fcCurrency }}
                  <div class="total-item text-xs text-primary-darkest/50">
                    {{ product.quantity }} Pcs ({{ product.unit_weight }}gr)
                  </div>
                </div>
              </div>
              <div class="see-more p-2" *ngIf="order.total_order_lines > 2">
                <div class="load-more text-center">
                  <button
                    class="py-1 px-3 text-primary-md-dark"
                    (click)="onPToggle(i)"
                    *ngIf="pToggle[i] == false">
                    Lihat Selengkapnya
                    <fa-icon [icon]="faChevronDown"></fa-icon>
                  </button>
                  <button
                    class="py-1 px-3 text-primary-md-dark"
                    (click)="onPToggle(i)"
                    *ngIf="pToggle[i] == true">
                    Tutup <fa-icon [icon]="faChevronUp"></fa-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center">
          <a routerLink="/user/order">
            <button
              class="rounded-md py-1 px-3 text-center text-lg font-medium text-primary-md-dark hover:bg-gray-100">
              View All
            </button>
          </a>
        </div>
      </div>
      <div class="loading text-center" *ngIf="loadOrder">
        <fa-icon class="load-icon" [icon]="faSpinner" [spin]="true"></fa-icon>
      </div>
    </section>
  </div>
</div>
